const fonts = {
  InterBold: require('./Inter-Bold.ttf'),
  InterRegular: require('./Inter-Regular.ttf'),
  InterSemibold: require('./Inter-SemiBold.ttf'),
};

export { fonts };
